import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, of, switchMap, takeUntil, throwError } from "rxjs";
import { StateService } from "@uirouter/core";
import { DestroyService } from "@webapp/core/util/services/destroy.service";

@Injectable({ providedIn: "root" })
export class AccountSuspendedInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private destroy$: DestroyService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      takeUntil(this.destroy$),
      switchMap((response: HttpResponse<any>) => {
        const stateService = this.injector.get(StateService);
        const destinationStateName = "accountSuspended";

        if (response.status === 402 && stateService.current.name !== destinationStateName) {
          stateService.go(destinationStateName, { reload: true });
          const error = new HttpErrorResponse({
            error: "Account Suspended",
            headers: request.headers,
            status: 402,
            statusText: "Account Suspended",
            url: request.url,
          });
          return throwError({ ...error });
        }

        return of(response);
      })
    );
  }
}
